import React from 'react'
import img2040 from '../components/images/ljiomart.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2040} alt='jiomart' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>Jio Mart Listing Services
                    </h2>
                    <p>Maximize your Jio platform presence with our expert listing services, designed to enhance visibility and drive sales. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services :</h3>
                <li><b>•	Product Listing:</b> Create optimized listings with detailed descriptions, high-quality images, and strategic keywords for better search visibility. </li>
                <li><b>•	Advertising Campaign:</b>Run targeted ad campaigns to increase product visibility and drive sales. </li>
                <li><b>•	Brand Registry:</b>Protect your brand and access advanced marketing tools by enrolling in Jio’s Brand Registry. </li>
                <li><b>•	Brand Approval:</b> Simplify the process for getting your brand approved on Jio, ensuring compliance with platform standards. </li>
                <li><b>•	Category Approval:</b> Streamline the approval process for specific categories to meet Jio’s requirements. </li>
                <li><b>•	Account Health:</b> Maintain a healthy account with compliance to Jio’s policies and performance standards. </li>
                <li><b>•	Order Processing:</b> Efficiently manage order fulfillment from receipt to delivery. </li>
                <li><b>•	Payment Reconciliation:</b> Ensure accurate transaction records and quickly resolve discrepancies.</li>
                <li><b>•	Keyword Optimization:</b> Improve search rankings and visibility with strategic keyword use. </li>
                <li><b>•	Safety Claim:</b> Manage and resolve product safety issues effectively. </li>
                <li><b>•	Basic Training:</b>Equip yourself with essential knowledge for effective account management. </li>
                <li><b>•	Sales Boost:</b>Implement strategies to increase sales through optimized listings and promotions.</li>
                <li><b>•	Deal Participation: </b> Easily participate in Jio’s special deals and promotional events to boost sales.</li>
            </ul>
        </>
    )
}

export default events